import { taskApi } from "../../api/taskApi"
import { accessToken } from "../../hooks/useAccessToken"
import { taskListSignal, taskListLoadingSignal, taskListErrorSignal } from "../signals/taskSignals"

export async function fetchTaskList(businessEntityId, filter, config, accessToken) {
    taskListLoadingSignal.value = true
    taskListErrorSignal.value = null

    try {
        const result = await taskApi.fetchTaskList(businessEntityId, filter, config, accessToken)
        taskListSignal.value = result.taskView
    }
    catch (err) {
        taskListErrorSignal.value = err.message
    }
    finally {
        taskListLoadingSignal.value = false
    }
}